import * as conf from '../conf/conf.js';

export const environment = {
	production: true,
	locale: conf.buildConfig.language,
	config: conf.buildConfig,
	userData: conf.userData,
	DEV_SPECS: false,
};
